// buefy removed this component in v0.7.0
// copied here to avoid rewriting existing code
import Panel from './Panel'

Vue.component(Panel.name, Panel)